// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/ChatList.css */
.chat-list {
  width: 250px;
  display: flex;
  flex-direction: column;
  background: #f9f9f9;
  height: 75vh;
}

/* Tabs */
.chat-tabs {
  display: flex;
  border-bottom: 1px solid #ddd;
}
.chat-tabs button {
  flex: 1 1;
  padding: 10px 0;
  border: none;
  background: #f1f1f1;
  cursor: pointer;
  font-weight: bold;
}
.chat-tabs button.active {
  background: #fff;
  border-bottom: 2px solid #0078d4;
  color: #0078d4;
}

/* Private search / New-Group */
.new-chat-area {
  padding: 10px;
  border-bottom: 1px solid #ddd;
}
.chat-search {
  width: 93%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.search-suggestions {
  max-height: 200px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #ddd;
  margin-top: 4px;
  border-radius: 4px;
}
.suggestion-item {
  display: flex;
  align-items: center;
  padding: 6px 8px;
  cursor: pointer;
}
.suggestion-item:hover {
  background: #f0f0f0;
}
.chat-avatar-small {
  width: 24px;
  height: 24px;
  margin-right: 8px;
  border-radius: 50%;
  object-fit: cover;
}
.no-suggest {
  padding: 8px;
  color: #888;
}
.new-group-btn {
  width: 100%;
  padding: 8px;
  background: #00468c;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.new-group-btn:hover {
  background: #013d78;
}

/* Rooms list */
.rooms-container {
  flex: 1 1;
  overflow-y: auto;
  overflow-anchor: none;
}
.chat-list-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid #ececec;
  width: 100%;
}
.chat-item-main {
  display: flex;
  align-items: center;
  flex: 1 1;
}
.chat-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 10px;
}
.chat-name {
  flex: 1 1;
}
.chat-list-item:hover {
  background: #e5f1fb;
  width: 100%;
}

/* Empty placeholder */
.empty-placeholder {
  padding: 20px;
  color: #666;
  text-align: center;
}

.chat-list-item-wrapper {
  display: flex;
  align-items: center;
}

/* highlight the selected chat */
.chat-list-item.active {
  background: #e5f1fb;
  border-left: 4px solid #0078d4;
  padding-left: 12px;
  width: 100%;
}

/* make sure the delete button stays nicely aligned */
.delete-group-btn {
  background: none;
  border: none;
  color: #888;
  margin-left: auto;
  cursor: pointer;
  padding: 12px;
}
.delete-group-btn:hover {
  color: #c00;
}

.unread-badge {
  display: inline-block;
  background: #e33;
  color: #fff;
  font-size: 0.75rem;
  border-radius: 12px;
  padding: 2px 6px;
  margin-left: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Chat/ChatList.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA,SAAS;AACT;EACE,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE,SAAO;EACP,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,SAAO;EACP,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;EAChC,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAO;AACT;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,SAAO;AACT;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;AACb;;AAEA,qDAAqD;AACrD;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,aAAa;AACf;AACA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB","sourcesContent":["/* src/components/ChatList.css */\n.chat-list {\n  width: 250px;\n  display: flex;\n  flex-direction: column;\n  background: #f9f9f9;\n  height: 75vh;\n}\n\n/* Tabs */\n.chat-tabs {\n  display: flex;\n  border-bottom: 1px solid #ddd;\n}\n.chat-tabs button {\n  flex: 1;\n  padding: 10px 0;\n  border: none;\n  background: #f1f1f1;\n  cursor: pointer;\n  font-weight: bold;\n}\n.chat-tabs button.active {\n  background: #fff;\n  border-bottom: 2px solid #0078d4;\n  color: #0078d4;\n}\n\n/* Private search / New-Group */\n.new-chat-area {\n  padding: 10px;\n  border-bottom: 1px solid #ddd;\n}\n.chat-search {\n  width: 93%;\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n.search-suggestions {\n  max-height: 200px;\n  overflow-y: auto;\n  background: #fff;\n  border: 1px solid #ddd;\n  margin-top: 4px;\n  border-radius: 4px;\n}\n.suggestion-item {\n  display: flex;\n  align-items: center;\n  padding: 6px 8px;\n  cursor: pointer;\n}\n.suggestion-item:hover {\n  background: #f0f0f0;\n}\n.chat-avatar-small {\n  width: 24px;\n  height: 24px;\n  margin-right: 8px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n.no-suggest {\n  padding: 8px;\n  color: #888;\n}\n.new-group-btn {\n  width: 100%;\n  padding: 8px;\n  background: #00468c;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n.new-group-btn:hover {\n  background: #013d78;\n}\n\n/* Rooms list */\n.rooms-container {\n  flex: 1;\n  overflow-y: auto;\n  overflow-anchor: none;\n}\n.chat-list-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  border-bottom: 1px solid #ececec;\n  width: 100%;\n}\n.chat-item-main {\n  display: flex;\n  align-items: center;\n  flex: 1;\n}\n.chat-avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  object-fit: cover;\n  margin-right: 10px;\n}\n.chat-name {\n  flex: 1;\n}\n.chat-list-item:hover {\n  background: #e5f1fb;\n  width: 100%;\n}\n\n/* Empty placeholder */\n.empty-placeholder {\n  padding: 20px;\n  color: #666;\n  text-align: center;\n}\n\n.chat-list-item-wrapper {\n  display: flex;\n  align-items: center;\n}\n\n/* highlight the selected chat */\n.chat-list-item.active {\n  background: #e5f1fb;\n  border-left: 4px solid #0078d4;\n  padding-left: 12px;\n  width: 100%;\n}\n\n/* make sure the delete button stays nicely aligned */\n.delete-group-btn {\n  background: none;\n  border: none;\n  color: #888;\n  margin-left: auto;\n  cursor: pointer;\n  padding: 12px;\n}\n.delete-group-btn:hover {\n  color: #c00;\n}\n\n.unread-badge {\n  display: inline-block;\n  background: #e33;\n  color: #fff;\n  font-size: 0.75rem;\n  border-radius: 12px;\n  padding: 2px 6px;\n  margin-left: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
